<template>
    <div class="day_wrap" :class="{ off: isOff, not_thismonth: isNotThisMonth }">
        <div v-if="isLoading" class="loading_bg round_none transparent" style="z-index: 999">
            <div class="loading_wrap">
                <div class="loading_obj">
                    <svg class="spinner" width="60px" height="60px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
                    </svg>
                </div>
            </div>
        </div>
        <div class="day">
            <div class="day_holiday_wrap">
                <span class="date">{{ dateString }}</span>
                <span class="label lgray" v-if="isHoliday">{{ $t('work_schedule.calendar.label_clinic_closed') }}</span>
            </div>
            <button v-if="!isHoliday && !isEditMode && !isNotWorkingTime" @click.stop="action_ShowEditLayer" class="btn btn_white btn_xs ico mgl_auto">
                <v-icon>mdi-pencil</v-icon>
            </button>
            <button class="btn btn_white btn_xs ico" @click.stop="action_ShowMenu" v-if="isNotWorkingTime == false">
                <v-icon>mdi-plus</v-icon>
            </button>
            <div class="workstatus_menu_layer_wrap" v-if="isShowMenu" v-clickoutside:action_OutsideOfMenu="{}">
                <div class="workstatus_menu_layer" v-if="!isHoliday">
                    <button class="menu_item" @click="action_CreateHoliday">
                        <v-icon class="menu_item_title">mdi-block-helper</v-icon>
                        <span class="menu_item_title">{{ $t('work_schedule.calendar.label_clinic_closed') }}</span>
                    </button>
                    <button class="menu_item" @click="action_Copy">
                        <v-icon class="menu_item_title">mdi-content-copy</v-icon>
                        <span class="menu_item_title">{{ $t('work_schedule.calendar.label_copy_schedule') }}</span>
                    </button>
                    <button class="menu_item" @click="action_Paste" :disabled="hasCopiedRecords == false">
                        <v-icon class="menu_item_title">mdi-content-paste</v-icon>
                        <span class="menu_item_title">{{ $t('work_schedule.calendar.label_paste_schedule') }}</span>
                    </button>
                </div>
                <div class="workstatus_menu_layer" v-if="isHoliday">
                    <button class="menu_item" @click="action_RemoveHoliday">
                        <v-icon class="menu_item_title">mdi-block-helper</v-icon>
                        <span class="menu_item_title">{{ $t('work_schedule.calendar.label_clinic_closed_release') }}</span>
                    </button>
                </div>
            </div>
        </div>
        <div v-if="!isEditMode && isOff == false">
            <CodeItem v-for="(record, index) in currentWorkRecords" :key="index" :record="record" />
            <div class="code_item etc" v-show="isShowBasicEmployee">
                <div class="staff_wrap">
                    <span class="staff" v-for="(title, index) in unselectedEmployeeTitles" :key="index">{{ title }}</span>
                </div>
            </div>
            <EditLayer :isOverlay="true" :date="date" :records="currentWorkRecords" :keyEventController="keyEventController" @hideEditLayer="hideEditLayer" />
        </div>
        <div v-show="isEditMode && isOff == false">
            <EditLayer ref="EditLayer" :isOverlay="false" :date="date" :records="currentWorkRecords" :keyEventController="keyEventController" @hideEditLayer="hideEditLayer" />
        </div>
    </div>
</template>

<script>
import { deepCopy } from '@/util/deep-copy'
import AlertController from '@/controller/AlertController'
import { sheetState } from '../../../../../../sheet-state'
import { workerState, setNeedUpdatePastedRecord, showCalendarMenu, hideCalendarMenu, showCalendarEditLayer, hideCalendarEditLayer, setCopiedRecords } from '../../../worker-state'
import { useManagingWorkers } from '@/composables/use-managing-workers'

import CodeItem from './CalendarCodeItem.vue'
import EditLayer from './CalendarEditItem/CalendarEditLayer.vue'
import { isApiErrorWithCode } from '@/apis/instances/check-api-response'
import { useV2WorkHolidayCreateMutation } from '@/composables/queries/v2workholiday/use-v2-workholiday-create-mutation'
import { useV2WorkHolidayRemoveMutation } from '@/composables/queries/v2workholiday/use-v2-workholiday-remove-mutation'
import { useV2WorkRecordUpdateMutation } from '@/composables/queries/v2workrecord/use-v2-workrecord-update-mutation'
import { useV2WorkRecordRemoveMutation } from '@/composables/queries/v2workrecord/use-v2-workrecord-remove-mutation'
import { useV2WorkRecordSendPushMutation } from '@/composables/queries/v2workrecord/use-v2-workrecord-send-push-mutation'

const moment = require('@/util/MPMoment')
export default {
    setup() {
        // 구 ManagingDataController 대체 — 이름 충돌 방지를 위해 allEmployees 로 노출
        const { employees: allEmployees } = useManagingWorkers()
        const { mutateAsync: createWorkHoliday } = useV2WorkHolidayCreateMutation()
        const { mutateAsync: removeWorkHoliday } = useV2WorkHolidayRemoveMutation()
        const { mutateAsync: updateWorkRecord } = useV2WorkRecordUpdateMutation()
        const { mutateAsync: removeWorkRecord } = useV2WorkRecordRemoveMutation()
        const { mutateAsync: sendPushWorkRecord } = useV2WorkRecordSendPushMutation()
        return { allEmployees, createWorkHoliday, removeWorkHoliday, updateWorkRecord, removeWorkRecord, sendPushWorkRecord }
    },
    components: { CodeItem, EditLayer },
    props: {
        selectedMonth: Object,
        date: Object,
        workRecords: Array,
        holidays: Array,

        keyEventController: Object
    },
    data() {
        return {
            alertController: AlertController,
            sheetState,
            worker: workerState,

            isShowEditLayer: false,
            isLoading: false
        }
    },
    watch: {
        isShowMenu: function (newValue) {
            if (newValue == false) {
                this.unregistESCKeyEventListener()
            } else {
                this.registESCKeyEventListener()
            }
        }
    },
    computed: {
        isShowCustomized: function () {
            return this.worker.isShowCustomTimeCode
        },
        isShowBasicEmployee: function () {
            return this.worker.isShowBasicEmployee
        },
        dateString: function () {
            return this.date.format('D')
        },
        isNotThisMonth: function () {
            if (this.selectedMonth.format('YYYYMM') == this.date.format('YYYYMM')) {
                return false
            }
            return true
        },
        isEditMode: function () {
            return this.worker.isModifyMode
        },
        reservationSetting: function () {
            return this.sheetState.reservationSetting
        },
        possibleTimes: function () {
            return this.reservationSetting.possibleTimes
        },
        isOff: function () {
            if (this.isHoliday == true) {
                return true
            }
            return this.isNotWorkingTime
        },
        isNotWorkingTime: function () {
            let dayNumber = this.date.format('d')
            let time = this.possibleTimes.find((p) => p.index == dayNumber)
            // TODO: check custom break schedules
            return !time.isSelected
        },
        selectedWorkCodes: function () {
            return this.worker.workCodes.filter((c) => c.isSelected == true)
        },
        selectedEmployees: function () {
            return this.allEmployees.filter((e) => e.isSelected == true)
        },
        currentWorkRecords: function () {
            let records = this.workRecords.filter((w) => moment(w.date).startOf('days').format('YYYY-MM-DDTHH:mm:ss') == this.date.startOf('days').format('YYYY-MM-DDTHH:mm:ss') && w._id != undefined)
            records.sort((l, r) => {
                let lNum = l.workCodeID?.sortNum ?? 999
                let rNum = r.workCodeID?.sortNum ?? 999
                return lNum > rNum ? 1 : -1
            })
            return records
        },
        unselectedEmployeeTitles: function () {
            let selectedEmployees = this.selectedEmployees
            let ids = []
            for (let i = 0; i < this.currentWorkRecords.length; i++) {
                ids = ids.concat(this.currentWorkRecords[i].employees.map((e) => e._id) ?? [])
            }
            let employees = selectedEmployees.filter((e) => !ids.includes(e._id))
            return employees.map((e) => e.title)
        },
        hasCopiedRecords: function () {
            return this.worker.copiedRecords != undefined
        },
        holiday: function () {
            return this.holidays.find((h) => moment(h.date).format() == moment(this.date).format())
        },
        isHoliday: function () {
            return this.holiday != undefined
        },
        isShowMenu: function () {
            return moment(this.worker.scheduleMenu_Date).format() == moment(this.date).format()
        }
    },
    methods: {
        action_ShowEditLayer() {
            if (this.worker.calendarEditLayer_Date != undefined) { return }
            hideCalendarMenu()
            showCalendarEditLayer(this.date)
        },
        action_HideEditLayer() {
            hideCalendarEditLayer()
        },
        action_ShowMenu() {
            hideCalendarEditLayer()
            showCalendarMenu(this.date)
        },

        async action_CreateHoliday() {
            // 저장 완료(캐시 invalidation 포함) 후 갱신 플래그를 세워야 재조회가 fresh 데이터를 읽는다
            await this.createHoliday()
            this.worker.needUpdateHolydays = true
            hideCalendarMenu()
        },
        async action_RemoveHoliday() {
            await this.removeHoliday()
            this.worker.needUpdateHolydays = true
            hideCalendarMenu()
        },
        action_Copy() {
            let dateKey = moment(this.date).format()
            // TODO: selected 여부 확인 필요
            let array = this.worker.modifiedRecords[dateKey].modifiedRecords.filter((w) => w.isSelected == true || (this.isShowCustomized == true && w.isCustomized))
            setCopiedRecords(array)
            this.ToastController.showToast('일정이 복사되었습니다.')
            hideCalendarMenu()
        },
        action_Paste() {
            if (this.isEditMode == true) {
                //paste records in copied
                let dateKey = moment(this.date).format()
                for (let i = 0; i < this.worker.copiedRecords.length; i++) {
                    let copiedRecord = this.worker.copiedRecords[i]
                    let copiedEmployees = copiedRecord.employees
                    let target = undefined
                    if (copiedRecord.isCustomized == true) {
                        target = this.worker.modifiedRecords[dateKey].modifiedRecords.find(
                            (r) =>
                                r.isCustomized == true &&
                                moment(r.startedAt).format('HH:mm') == moment(copiedRecord.startedAt).format('HH:mm') &&
                                moment(r.endedAt).format('HH:mm') == moment(copiedRecord.endedAt).format('HH:mm')
                        )
                    } else {
                        target = this.worker.modifiedRecords[dateKey].modifiedRecords.find((r) => r.workCodeID?._id == copiedRecord.workCodeID._id)
                    }
                    if (target == undefined) {
                        target = {
                            date: moment(this.date).format(),
                            hospitalID: copiedRecord.hospitalID,
                            employees: copiedRecord.employees,
                            isCustomized: copiedRecord.isCustomized,
                            isSelected: copiedRecord.isSelected,
                            workCodeID: copiedRecord.workCodeID,
                            startedAt: copiedRecord.startedAt,
                            endedAt: copiedRecord.endedAt
                        }
                        this.worker.modifiedRecords[dateKey].modifiedRecords.push(target)
                    } else {
                        let targetIndex = this.worker.modifiedRecords[dateKey].modifiedRecords.indexOf(target)
                        if (targetIndex < 0) {
                            continue
                        }
                        this.worker.modifiedRecords[dateKey].modifiedRecords[targetIndex].employees = copiedEmployees
                    }
                    this.worker.modifiedRecords[dateKey].isModified = true
                }
                setNeedUpdatePastedRecord(true)
            } else {
                this.copyRecords()
            }
            hideCalendarMenu()
        },
        action_OutsideOfMenu() {
            hideCalendarMenu()
        },

        // MARK: - Network
        async createHoliday() {
            let hospitalID = this.hospital.selectedHospital._id
            let model = {
                hospitalID: hospitalID,
                date: this.date
            }
            try {
                await this.createWorkHoliday(model)
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남긴다
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
            }
        },
        async removeHoliday() {
            let holidayID = this.holiday._id
            let model = {
                _id: holidayID
            }
            try {
                await this.removeWorkHoliday(model)
            } catch (err) {
                // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남긴다
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
            }
        },
        async copyRecords() {
            this.isLoading = true
            let removalRecords = this.currentWorkRecords.filter((r) => r._id != undefined)
            for (let i = 0; i < removalRecords.length; i++) {
                let _id = removalRecords[i]._id
                let model = {
                    _id: _id
                }
                try {
                    await this.removeWorkRecord(model)
                } catch (err) {
                    // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 다음 항목 진행
                    if (!isApiErrorWithCode(err)) throw err
                    console.log(err)
                }
            }
            let copiedRecords = deepCopy(this.worker.copiedRecords)
            for (let i = 0; i < copiedRecords.length; i++) {
                let copied = copiedRecords[i]
                let model = {
                    hospitalID: copied.hospitalID,
                    date: this.date,
                    workCodeID: copied.workCodeID?._id,
                    employees: copied.employees,
                    isCustomized: copied.isCustomized,
                    startedAt: copied.startedAt,
                    endedAt: copied.endedAt,
                    isRemoved: false
                }
                try {
                    await this.updateWorkRecord(model)
                } catch (err) {
                    // 기존 동작 미러링: 봉투 code != 0 이면 로그만 남기고 다음 항목 진행
                    if (!isApiErrorWithCode(err)) throw err
                    console.log(err)
                }
            }

            // notification
            let hospitalID = this.hospital.selectedHospital._id
            let s = moment(this.date).startOf('days')
            let e = moment(this.date).endOf('days')
            try {
                await this.sendPushWorkRecord({
                    data: {
                        hospitalID: hospitalID,
                        startDate: s.format(),
                        endDate: e.format()
                    }
                })
            } catch (err) {
                // 기존 동작 미러링: 푸시 봉투 에러는 확인하지 않았다
                if (!isApiErrorWithCode(err)) throw err
                console.log(err)
            }
            this.isLoading = false
        },

        // MARK: - Emit
        hideEditLayer() {
            this.isShowEditLayer = false
        },

        // MARK: - Regist ESC Key Down
        registESCKeyEventListener() {
            window.addEventListener('keydown', this.handleESCKeyEvent)
        },
        unregistESCKeyEventListener() {
            window.removeEventListener('keydown', this.handleESCKeyEvent)
        },
        handleESCKeyEvent(e) {
            let key = e.key
            if (key == 'Escape') {
                if (this.isShowMenu == true) {
                    this.action_OutsideOfMenu()
                }
            }
        }
    }
}
</script>

<style scoped>
.workstatus_menu_layer {
    position: absolute;
    z-index: 10;
    background: #fff;
    border: 1px solid #000;
    display: flex;
    flex-direction: column;
    padding: 5px;
}

.menu_item {
    display: flex;
    align-items: center;
    padding: 5px;
    gap: 5px;
    line-height: 1;
    border: 1px solid transparent;
    border-radius: 0;
}

.menu_item:disabled {
    color: #cccccc;
}

.menu_item:hover {
    display: flex;
    align-items: center;
    padding: 5px;
    gap: 5px;
    line-height: 1;
    border: 1px solid var(--yellow50);
    background-color: var(--yellow30);
}

.menu_item:disabled:hover {
    border: 1px solid transparent;
    background-color: transparent;
    /* 20240526 지호
        근무일정 일정 추가액션 오버레이에서 일정 붙여넣기 disabled시 마우스 hover 효과 비활성화
    */
}

.menu_item_title {
    max-width: 100%;
    display: inline;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    vertical-align: middle;
    font-size: 12px;
}

.workstatus_menu_layer_wrap {
    position: absolute;
    top: 20px;
    right: 120px;
}

.day_holiday_wrap {
    display: flex;
    gap: 8px;
}

.day_holiday_wrap span {
    margin-left: 0 !important;
}
</style>
